export const domainLogos = {
  "localhost": "/logos/palazzo.png",
  "betzone24.com": "/logos/betzon.png",
  "betsclub.co": "/logos/betsclub.png",
  "bet90.plus": "/logos/90pluss.png",
  "floybet.com": "/logos/floybet.png",
  "floybets.com": "/logos/floybet.png",
  "palazzocasino365.com": "/logos/palazzo.png",
}